import React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CImage,
  CRow,
} from '@coreui/react'
import logo from '../../assets/images/icons/ne_logo_small.png'
import argLogo from '../../assets/images/icons/arg_logo_white.png'
import { useSelector } from 'react-redux'
import { withRouter } from 'src/withRouter'
import { getMemberFullName } from 'src/util/modelUtil'
import { useNavigate } from 'react-router-dom'

const AutoEnrollFinish = () => {
  const member = useSelector((state) => state.members.autoEnrolled)
  const navigate = useNavigate()

  if (!member) return
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6} className="mt-3 mb-3">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <div className="text-center">
                    <h1>Nous y voilà !</h1>
                    <p className="text-medium-emphasis">
                      Cher(e) <b>{getMemberFullName(member)}</b>, merci de nous avoir rejoints.
                      <br /> Considérez d&apos;ores et déjà ce parti comme votre nième famille.
                      <br />
                      Votre adhésion est maintenant enregistrée sous le code{' '}
                      <strong>{member.memberCode2}</strong>. Vous pouvez dès maintenant commander et
                      payer votre carte de membre en ligne. <br />
                      En attendant, vous pouvez poursuivre votre navigation dans{' '}
                      <a href="https://nouvelelan-rdc.com">
                        le site d&apos;informations accessible ici
                      </a>{' '}
                      ou revenir <strong>enregistrer un nouveau membre</strong> en cliquant sur le
                      bouton ci-desous.
                    </p>
                    <CButton
                      color="primary"
                      size="lg"
                      onClick={() => navigate('/member-card/order', { state: { member } })}
                      style={{ margin: '10px auto', display: 'block' }}
                    >
                      Commander ma carte de membre
                    </CButton>
                    <CButton
                      color="light"
                      onClick={() => {
                        navigate('/members/enroll')
                      }}
                      style={{ margin: '10px auto' }}
                    >
                      Enregistrer un autre membre
                    </CButton>
                  </div>
                  <div
                    className="text-white text-center bg-info py-5"
                    style={{
                      marginLeft: -40,
                      marginRight: -40,
                      marginBottom: -40,
                      borderBottomLeftRadius: 6,
                      borderBottomRightRadius: 6,
                    }}
                  >
                    <CImage src={logo} height={80} />
                    <br />
                    <br />
                    <p>
                      <b>Nouvel Elan : </b> Unité - Travail - Développement !
                    </p>
                    <br />
                    <br />
                    <div style={{ position: 'absolute', bottom: 20, right: 20 }}>
                      <span style={{ fontStyle: 'italic' }}>Powered by </span>
                      <CImage src={argLogo} height={30} title="Argile Groupe, Kinshasa / RDC" />
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default withRouter(AutoEnrollFinish)
